import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { useAllAdvertisersForSearchOptions, useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { UsersFilterFormKeys } from './schemaTypes';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { allAdvertiserOptions, loading } = useAllAdvertisersForSearchOptions();
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();

  return (
    <Form.Fields>
      <TextSearchField<UsersFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        title={t('Search.Keyword')}
        placeholder={t<string>('Search.UserFilter')}
      />

      <SelectorField<UsersFilterFormKeys>
        title={t('Selector.Advertisers')}
        disabled={loading}
        onSubmit={onSubmit}
        name="advertiserIds"
        className="max-w-78.5"
        options={allAdvertiserOptions}
        multiple
      />

      <SelectorField<UsersFilterFormKeys>
        title={t('Selector.Country')}
        name="countryId"
        onSubmit={onSubmit}
        className="max-w-48.5"
        options={allAvailableCountryOptions}
      />
    </Form.Fields>
  );
};
